/// NAV
const menuToggle = document.querySelector('.menu-btn');
const body = document.querySelector('body');

if(menuToggle){
  menuToggle.addEventListener('click', () => {
  body.classList.toggle('open');
  console.log("open");
});
}

/* 
    TimeTable
*/
const timetableToggle = document.querySelectorAll('.timetableToggle');
if (timetableToggle) {
  timetableToggle.forEach(function (toggle) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      body.classList.toggle('timetable-open');
      console.log("timetable-open");
    });
  })
}

/* 
    TimeTable
*/
document.addEventListener('DOMContentLoaded', function () {
  // Sélectionner tous les en-têtes d'accordéon
  const headers = document.querySelectorAll('.infos-header');
  if (headers) {
    // Ajouter un écouteur d'événement à chaque en-tête
    headers.forEach(header => {
      header.addEventListener('click', function (e) {
        // Empêcher la propagation du clic vers les éléments parents
        e.stopPropagation();

        // Récupérer le container parent
        const container = this.parentElement;

        // Toggle la classe active sur le container
        container.classList.toggle('active');
      });
    });
  }
});

/// logo ANIM
/* 
document.addEventListener("DOMContentLoaded", function () {
  const video_header = document.getElementById("logoVideo_header");

  // Jouer la vidéo en boucle à partir de 2s jusqu'à 5s
  if (video_header !== null) {
    video_header.addEventListener("loadedmetadata", function () {
      console.log('video_header');
      video_header.currentTime = 2.5; // Démarrer à 2 secondes
      video_header.play();
      video_header.addEventListener("ended", function () {
        setTimeout(() => {
          video_header.currentTime = 2.5;
          video_header.play();
        }, 3000); // Pause de 5 secondes avant redémarrage
      });
    });
  }
});
 */

document.addEventListener("DOMContentLoaded", function () {
  const video_header = document.getElementById("logoVideo_header");

  if (video_header !== null) {

    // Fonction pour gérer la lecture de la vidéo
    video_header.play().catch(error => {
      console.log("Lecture automatique bloquée, tentative de redémarrage...");
      video.muted = true; // S'assurer que la vidéo est bien muette
      video.play();
    });

    // Fonction pour gérer la lecture de la vidéo
    const handleVideoEnd = () => {
      video_header.pause(); // On met d'abord la vidéo en pause
      setTimeout(() => {
        video_header.currentTime = 0; // On définit le point de départ à 2.5 secondes
        video_header.play(); // On relance la lecture
      }, 3000); // Attente de 3 secondes
    };

    // Initialisation de la vidéo une fois les métadonnées chargées
    video_header.addEventListener("loadedmetadata", function () {
      video_header.play(); // Première lecture
    });

    // Gestion de la fin de la vidéo
    video_header.addEventListener("ended", handleVideoEnd);
  }
});
// MARQUEE
// Marquee Banner Functionality
function createMarquee(element) {
  // Prevent multiple initializations
  if (element.querySelector('.marquee-inner')) return;

  const content = element.textContent;
  const speed = parseFloat(element.dataset.speed) || 50;
  const direction = element.dataset.direction || 'left';

  // Clear original content
  element.innerHTML = '';

  // Create wrapper and inner container
  const wrapper = document.createElement('div');
  wrapper.style.overflow = 'hidden';
  wrapper.style.width = '100%';

  const inner = document.createElement('div');
  inner.classList.add('marquee-inner');
  inner.style.display = 'inline-flex';
  inner.style.whiteSpace = 'nowrap';

  // Create two identical content spans for seamless looping
  const createContentSpan = () => {
    const span = document.createElement('span');
    span.textContent = content;
    span.style.marginRight = '50px';
    return span;
  };

  // Create duplicate content sets
  const firstSet = document.createElement('div');
  const secondSet = document.createElement('div');
  firstSet.style.display = 'inline-flex';
  secondSet.style.display = 'inline-flex';

  for (let i = 0; i < 5; i++) {
    firstSet.appendChild(createContentSpan());
    secondSet.appendChild(createContentSpan());
  }

  inner.appendChild(firstSet);
  inner.appendChild(secondSet);
  wrapper.appendChild(inner);
  element.appendChild(wrapper);

  // Animate
  const animate = () => {
    const totalWidth = firstSet.scrollWidth;

    inner.style.transition = 'none';
    inner.style.transform = direction === 'left'
      ? 'translateX(0)'
      : `translateX(-${totalWidth}px)`;

    // Force reflow
    inner.offsetHeight;

    // Start sliding animation
    inner.style.transition = `transform ${speed}s linear`;
    inner.style.transform = direction === 'left'
      ? `translateX(-${totalWidth}px)`
      : 'translateX(0)';
  };

  // Reset animation when it completes
  inner.addEventListener('transitionend', () => {
    inner.style.transition = 'none';
    inner.style.transform = direction === 'left'
      ? 'translateX(0)'
      : `translateX(-${firstSet.scrollWidth}px)`;

    // Trigger next animation cycle
    requestAnimationFrame(animate);
  });

  // Initial animation
  requestAnimationFrame(animate);
}

// Initialize marquee banners
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.marquee').forEach(createMarquee);
});




///////// LISTE SCROLL
document.addEventListener('DOMContentLoaded', function () {
  // Select all horizontal artist list containers
  const artistListContainers = document.querySelectorAll('.scroll');

  artistListContainers.forEach(container => {
    const scrollContainer = container.querySelector('.scroll-container');
    const prevBtn = container.querySelector('.artist-nav-btn.artist-nav-prev');
    const nextBtn = container.querySelector('.artist-nav-btn.artist-nav-next');
    const artistBlocks = scrollContainer.querySelectorAll('.bloc-artiste');

    scrollContainer.style.scrollSnapType = 'x mandatory';

    updateNavButtons();


    // Navigation logic
    nextBtn.addEventListener('click', () => {
      const currentScroll = scrollContainer.scrollLeft;
      const containerWidth = scrollContainer.clientWidth;

      const nextBlockIndex = Array.from(artistBlocks).findIndex(block =>
        block.offsetLeft > currentScroll + containerWidth / 2
      );

      if (nextBlockIndex !== -1) {
        artistBlocks[nextBlockIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        setTimeout(updateNavButtons, 300);
      }
    });

    prevBtn.addEventListener('click', () => {
      // Always scroll to the first block
      artistBlocks[0].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });

      setTimeout(updateNavButtons, 300);
    });

    // Function to manage button visibility
    function updateNavButtons() {
      const isAtStart = scrollContainer.scrollLeft <= 1;
      const isAtEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1;

      prevBtn.style.display = isAtStart ? 'none' : 'block';
      nextBtn.style.display = isAtEnd ? 'none' : 'block';
    }

    // Add scroll event listener to update buttons
    scrollContainer.addEventListener('scroll', updateNavButtons);

  });
});

// js/app.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// LENIS
/* import Lenis from 'lenis'


// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);
 */



// Import GSAP et ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const home_decor = document.querySelector('.home-decor');

if (home_decor !== null) {
  // Animation pour la div .home-logo
  gsap.to(".home-logo", {
    y: "60vh", // La div suit le scroll verticalement
    scale: 2, // Grossit à mesure que l'utilisateur descend
    opacity: 0,
    scrollTrigger: {
      trigger: ".home-decor", // La div est animée dans la zone du container
      start: "top top",      // Début de l'animation
      end: "bottom top",     // Fin de l'animation
      scrub: true,           // Synchronise l'animation avec le scroll
      ease: 'ease'
    },
  });

  // Animation pour la div .home-logo
  gsap.to(".home-etoile", {
    y: "-5vh", // La div suit le scroll verticalement
    //scale: 2, // Grossit à mesure que l'utilisateur descend
    opacity: 0,
    scrollTrigger: {
      trigger: ".home-decor", // La div est animée dans la zone du container
      start: "top top",      // Début de l'animation
      end: "bottom top",     // Fin de l'animation
      scrub: true,           // Synchronise l'animation avec le scroll
      ease: 'ease'
    },
  });
  // Animation pour l'élément gauche
  gsap.to(".home-main-g", {
    x: "-100vw", // L'élément sort par la gauche
    rotate: "-30deg",
    scrollTrigger: {
      trigger: ".home-decor", // Déclenche l'animation lorsque le container est visible
      start: "top top",      // Quand le haut du container atteint le haut de l'écran
      end: "bottom top",     // Quand le bas du container atteint le haut de l'écran
      scrub: true,           // Synchronise l'animation avec le scroll
      ease: 'ease'
    }
  });

  // Animation pour l'élément droit
  gsap.to(".home-main-gd", {
    x: "100vw", // L'élément sort par la droite
    rotate: "180deg",
    scrollTrigger: {
      trigger: ".home-decor",
      start: "top top",
      end: "bottom top",
      scrub: true,
      ease: 'ease'
    }
  });
  // Animation pour l'élément visage
  gsap.to(".home-visage", {
    y: "100vh", // L'élément sort par la droite
    scrollTrigger: {
      trigger: ".home-decor",
      start: "top top",
      end: "bottom top",
      scrub: true,
      ease: 'ease'
    }
  });
}


///////// ARTISTE LISTE

// Fonction pour générer une rotation aléatoire entre -3 et 3
function randomRotation() {
  return Math.random() * 6 - 3; // Génère un nombre entre -3 et 3
}
// Sélectionne tous les blocs
const blocs = document.querySelectorAll(".bloc-artiste");

if (blocs !== null) {
  // Applique une animation à chaque bloc
  blocs.forEach((bloc, index) => {
    gsap.fromTo(
      bloc,
      {
        //opacity: 0, // Invisible au départ
        y: 20, // Décalé vers le bas
        rotate: 0, // Décalé vers le bas
      },
      {
        //opacity: 1, // Visible
        y: 0, // À sa position d'origine
        rotate: randomRotation(),
        duration: 0.2, // Durée de l'animation
        delay: index * 0.1, // Décalage entre chaque bloc
        scrollTrigger: {
          trigger: bloc, // Déclenche l'animation lorsqu'il entre dans la vue
          start: "top 80%", // L'animation démarre lorsque le haut du bloc atteint 80% de la fenêtre
          end: "top 60%", // L'animation se termine lorsque le bloc atteint 60%
          toggleActions: "play none none none", // Joue l'animation une fois
        },
      }
    );
  });
}
/*
// Animation en boucle pour les rotations
const rotateTimelineLeft = gsap.timeline({ repeat: -1, yoyo: true });
rotateTimelineLeft.to(".home-main-g", {
  rotation: 27, // Inclinaison à 5 degrés
  duration: 3, // Durée de l'animation
  ease: "power1.inOut", // Transition douce
});

const rotateTimelineRight = gsap.timeline({ repeat: -1, yoyo: true });
rotateTimelineRight.to(".home-main-gd", {
  rotation: 160, // Inclinaison à -5 degrés
  duration: 3, // Durée de l'animation
  ease: "power1.inOut", // Transition douce
});*/
/*
import Swup from 'swup';
const swup = new Swup();

import { gsap } from "gsap";
swup.hooks.replace('animation:in:end', () => {
    body.classList.remove('open');
    console.log('startchange');
});

swup.hooks.replace('animation:out:await', async () => {
    
  await gsap.to('.transition-fade', { opacity: 0, duration: 0.25 });
});
swup.hooks.replace('animation:in:await', async () => {
  await gsap.fromTo('.transition-fade', { opacity: 0 }, { opacity: 1, duration: 0.25 });
});
*/